// preorder-watch.js
(() => {
  const PREORDER_CLASS = "preorder";

  const isPreorderText = (txt) => {
    if (!txt) return false;
    const t = txt.trim().toLowerCase();
    // covers: "Pre-order", "Pre order", "Preorder"
    return t.includes("preorder") || t.includes("pre-order") || t.includes("pre order");
  };

  const findScope = (el) => {
    // try to scope to the current product area first
    return (
      el.closest("[data-product-form]") ||
      el.closest("form") ||
      el.closest("section") ||
      el.closest(".product") ||
      document
    );
  };

  const updateForTextNode = (textEl) => {
    const scope = findScope(textEl);

    const instock = scope.querySelector(".instock-div") || document.querySelector(".instock-div");
    if (!instock) return;

    const txt =
      textEl.getAttribute("data-add-to-cart-text") ||
      textEl.textContent ||
      "";

    instock.classList.toggle(PREORDER_CLASS, isPreorderText(txt));
  };

  const attach = (textEl) => {
    // run once immediately
    updateForTextNode(textEl);

    // observe text + attribute changes
    const mo = new MutationObserver(() => updateForTextNode(textEl));
    mo.observe(textEl, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-add-to-cart-text"],
    });
  };

  const init = () => {
    document
      .querySelectorAll("[data-add-to-cart-text]")
      .forEach(attach);

    // if the theme re-renders the button, catch new nodes
    const bodyObs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes || []) {
          if (!(node instanceof Element)) continue;

          if (node.matches?.("[data-add-to-cart-text]")) attach(node);
          node
            .querySelectorAll?.("[data-add-to-cart-text]")
            .forEach(attach);
        }
      }
    });

    bodyObs.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();